__webpack_require__.p = "/Daily-Menu-May-2023/";